<i18n>
{
	"no": {
		"cancelLabel" : "Lukk",
		"header" : "Utgående EDI detaljer",
		"details": "Detaljer",
		"ediMessage" : "EDI melding",
		"errorMessage" : "Feilmeldinger",
		"orderDetails" : "Oppdrag",
		"numberOfOrdersInTransmission" : "Antall oppdrag: {count}",
		"id" : "TransmissionId: {id}",
		"tripId": "TripId: {id}",
		"creationErrors" : "Denne EDI meldingen har feil / bug ved generering og blir ikke sendt",
		"sendingErrors" : "Denne EDI meldingen har feil ved sending. Meldingen er ikke sendt",
		"notSent" : "Denne EDI meldingen er generert men har ikke blitt sendt enda",
		"success" : "Denne EDI meldingen er generert og sendt",
		"downloadEdiFIle" : "Last ned EDI fil",
		"resendFile": "Re-send melding",
		"fileAlreadySent": "EDI meldingen er allerede sent. Ønsker du virkelig å sende meldingen igjen?"
	},
	"en": {
		"details": "Details",
		"cancelLabel" : "Close",
		"header" : "Inspekasjon av utgående EDI forsendelse",
		"ediMessage" : "EDI message",
		"orderDetails" : "Oppdrag",
		"errorMessage" : "Errors",
		"numberOfOrdersInTransmission" : "Number of orders: {count}",
		"id" : "TransmissionId: {id}",
		"tripId": "TripId: {id}",
		"creationErrors" : "This EDI message has creation errors and will not be sent",
		"sendingErrors" : "This EDI message has sending errors and has not been sent",
		"notSent" : "This EDI message has been created successfully but not been sent yet",
		"success" : "This EDI message has been created successfully and sent",
		"downloadEdiFIle" : "Download EDI file",
		"resendFile": "Resend message",
		"fileAlreadySent": "EDI message has already been sent. Do you really wish to send it again?"
	}

}
</i18n>
<template>

	<t-dialog
		:isShown="isShown"
		:cancelLabel="$t('cancelLabel')"
		:icon="getCorrectIcon.icon"
		:iconType="'bp'"
		:title="getCorrectTitle"
		:iconColor="getCorrectIcon.color"
		@close="$emit('close')"
		@cancel="$emit('close')"
	>

		<div class="inspect-dialog">
			<div class="inspect-nav">
				<h4>{{$t('header')}}</h4>
				<t-tab-list :items="tabs" :selected.sync="selectedTab" sidebar>
					<template v-slot="slotProps">
						<t-tab :value="slotProps.item" :selected="slotProps.isSelected" :sidebar="slotProps.sidebar">
							{{$t(slotProps.item.key)}}
						</t-tab>
					</template>
				</t-tab-list>
			</div>
			<t-pane class="settings-content">
				<component :is="selectedTab.id" :ref="selectedTab.ref" :ordersAndErrors="ordersAndErrors"/>
			</t-pane>
		</div>
		<template #footer>
			<div class="button-panel">
				<t-button
					appearance="minimal"
					type="bp"
					intent="success"
					iconBefore="refresh"
					@click="setCurrentTransmission"
				/>
				<t-button
					:value="$t('downloadEdiFIle')"
					appearance="primary"
					type="bp"
					iconBefore="arrow-down"
					tabindex="-1"
					@click="downloadEdiFile"
				/>
				<t-button
					:value="$t('resendFile')"
					type="bp"
					iconBefore="arrow-up"
					tabindex="-1"
					@click="resendTransmission"
				/>
			</div>
		</template>

		<ConfirmDialog
			:isShown="showConfirmDialog"
			:title="$t('resendFile')"
			:description="$t('fileAlreadySent')"
			@yes="resendTransmissionForcefully"
			@close="showConfirmDialog = false"
		/>
	</t-dialog>

</template>

<script>

import Details from './Details.vue';
import EdiMessage from './EdiMessage.vue';
import OriginalMessage from './OriginalMessage.vue';
import OrderDetails from '../common/OrderDetails.vue';
import ErrorMessage from './ErrorMessage.vue';
import ConfirmDialog from '../common/ConfirmDialog';
import { mapGetters, mapActions } from './store/outbound.store';
import { baseUrl } from '@/core';
import { edi } from '@/requests';
export default {
	components: { Details, EdiMessage, OriginalMessage, ErrorMessage, ConfirmDialog, OrderDetails },
	props: { isShown: Boolean },
	data() {
		return {
			tabs: [{ id:'Details', key: 'details', ref: 'details' }, { id:'EdiMessage', key: 'ediMessage', ref: 'ediMessage' }, { id:'OrderDetails', key: 'orderDetails', ref: 'orderDetails' }, { id:'ErrorMessage', key: 'errorMessage', ref: 'errorMessage' }],
			selectedTab: { id:'Details', key: 'details', ref: 'details' },
			showConfirmDialog: false,
		};
	},

	computed: {
		...mapGetters(['getTransmissionDetails']),
		getCorrectTitle() {
			if (this.getTransmissionDetails.creationErrors)
				return this.$t('creationErrors');
			if (this.getTransmissionDetails.sendingErrors)
				return this.$t('sendingErrors');
			if (!this.getTransmissionDetails.sent)
				return this.$t('notSent');
			return 	this.$t('success');
		},
		getCorrectIcon() {
			if (this.getTransmissionDetails.creationErrors)
				 return  { icon: 'cross', color: 'red' };
			if (this.getTransmissionDetails.sendingErrors)
				return  { icon: 'time', color: 'red' };
			if (!this.getTransmissionDetails.sent)
				return  { icon: 'time', color: 'blue' };
			return { icon: 'tick', color: 'green' };
		},

		ordersAndErrors() {

			let orders = this.getTransmissionDetails.originalMessage || [];
			let orderArray = Array.isArray(orders) ? orders : [orders];
			let orderIds = orderArray.map(this.mapOrderIds);
			return {
				orderIds: orderIds,
				originalData: orders,
				error: this.getTransmissionDetails.creationErrors || this.getTransmissionDetails.sendingErrors
			};
		},
	},

	methods: {
		...mapActions(['resendOutboundTransmission', 'inspectOutboundTransmission']),
		downloadEdiFile() {
			let url = edi.downloadOutboundEdiFile(this.getTransmissionDetails.id);
			let fullyQualifiedUrl = baseUrl() + url;
			window.open(fullyQualifiedUrl);
		},
		mapOrderIds(data) {
			if (this.getTransmissionDetails.setup.messageType === 2)
				return data.orderId;
			else
				return data.mainOrderId;
		},
		resendTransmission() {
			if (this.getTransmissionDetails.sent)
				this.showConfirmDialog = true;
			else
				this.resendTransmissionForcefully(this.getTransmissionDetails.id);
		},
		resendTransmissionForcefully() {
			this.resendOutboundTransmission(this.getTransmissionDetails.id);
			this.showConfirmDialog = false;
		},
		setCurrentTransmission() {
			this.inspectOutboundTransmission(this.getTransmissionDetails.id);
		}
	}
};

</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

.inspect-dialog{
	display: grid;
	grid-template-columns: 240px 1100px;
}

.inspect-nav{
	border-right: 2 px solid get-color($border, 'default');
}

.button-panel{
	display:flex;
	justify-content: space-between;
	flex-basis: calc(30% - 45px);
}


</style>